import React from "react";
import { styled, SxProps, Box, Stack, Typography, Card, Button, Chip, Link } from "@mui/material";

import ConfigContentRecaps, {
  ConfigContentRecapsProps,
} from "../../Config/ConfigContentRecaps/config-content-row-recap";
import PrioritySelect from "../../Misc/PrioritySelect";

import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import TitleCard from "../TitleCard";
import { OrderProductType } from "../../../Core/Api/Types/order-product-type";
import OrderThumbnail from "../../Misc/OrderThumbnail/order-thumbnail";
import { useTranslation } from "react-i18next";

export type OrderHorizontalCardProps = {
  className?: string;
  sx?: SxProps;
  itemId: number;
  title: string;
  titleId: number;
  subtitle: string;
  thumbnail: string;
  priority: "low" | "medium" | "high" | "urgent";
  config: {
    title: string;
    configType: OrderProductType;
    price: string;
    content: ConfigContentRecapsProps;
    attachement?: string;
  };
  onClickConfigDetails?: () => void;
};

const OrderHorizontalAdvancedCard: React.FC<OrderHorizontalCardProps> = (props) => {
  const { t } = useTranslation();
  const { itemId, priority, config, title, titleId, subtitle, thumbnail, onClickConfigDetails = undefined } = props;

  return (
    <Wrapper variant="outlined">
      <Stack spacing={1} justifyContent="space-between" direction="row" alignItems="center" mb={2}>
        <Stack flex={1}>
          <Typography variant="subtitle2" fontWeight={600}>
            {config.title}
          </Typography>
          <Box mt={0.5}>
            <ConfigContentRecaps color="text.tier" {...config.content} />
          </Box>
        </Stack>
        <Stack alignItems="flex-end" flex={1}>
          <OrderThumbnail type={config.configType} />
        </Stack>
      </Stack>
      {/*<Stack direction="row" spacing={1} mb={2}>
        <Chip label="Missing assets" variant="outlined" color="warning" icon={<BuildCircleOutlinedIcon />} />
  </Stack>*/}
      <TitleCard poster={thumbnail} title={title} titleId={titleId} subtitle={subtitle} price={config.price} />
      <Stack direction="row" alignItems="center" justifyContent="space-between" mt={2}>
        <Link color="primary.text" underline="hover" onClick={onClickConfigDetails}>
          {t("button:configDetails")}
          <ChevronRightOutlinedIcon sx={{ ml: 0.5 }} />
        </Link>
        <Stack direction="row" spacing={1}>
          {/*<Button size="small" startIcon={<EditOutlinedIcon />}>
            Edit
        </Button>*/}
          <Button size="small" startIcon={<PrintOutlinedIcon />}>
            {t("common:print")}
          </Button>
        </Stack>
      </Stack>
    </Wrapper>
  );
};

const Wrapper = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: 8,
  backgroundImage: "none",
  boxShadow: "none",
}));

export default OrderHorizontalAdvancedCard;
